import { AnchorScrollTo } from "../../atoms/index.js";
import { withDeprecation } from "../../decorators/withDeprecation.js";
class TableOfContentAnchor extends withDeprecation(
  AnchorScrollTo
) {
  /**
   * Config.
   */
  static config = {
    name: "TableOfContentAnchor",
    emits: ["should-activate"],
    options: {
      activeClass: {
        type: String,
        default: "is-active"
      }
    }
  };
  /**
   * Observer.
   * @private
   */
  __observer;
  /**
   * Get the sentinel.
   */
  get sentinel() {
    return document.querySelector(this.targetSelector);
  }
  /**
   * Init observer on mount.
   */
  mounted() {
    if (!this.sentinel) {
      return;
    }
    this.__observer = new IntersectionObserver(([entry]) => {
      const shouldActivate = entry.isIntersecting && entry.boundingClientRect.y < 100 && entry.boundingClientRect.y > -100;
      this.$el.classList.toggle(this.$options.activeClass, shouldActivate);
      this.$emit("should-activate", shouldActivate);
    });
    this.__observer.observe(this.sentinel);
  }
  /**
   * Destroy observer on destroy.
   */
  destroyed() {
    this.__observer.disconnect();
  }
}
export {
  TableOfContentAnchor
};
//# sourceMappingURL=TableOfContentAnchor.js.map
